/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Collector_SetInputs */

const en_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collector Set`)
};

const es_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set de coleccionista`)
};

const fr_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffret collector`)
};

const de_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammleredition`)
};

const ja_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクターセット`)
};

const zh_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收藏套装`)
};

const ar_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعة هواة الجمع`)
};

const id_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Kolektor`)
};

const it_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edizione per Collezionisti`)
};

const ru_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коллекционный набор`)
};

const pt_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto de Colecionador`)
};

const ko_val_collector_set = /** @type {(inputs: Val_Collector_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컬렉터 세트`)
};

/**
* | output |
* | --- |
* | "Collector Set" |
*
* @param {Val_Collector_SetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_collector_set = /** @type {((inputs?: Val_Collector_SetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Collector_SetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_collector_set(inputs)
	if (locale === "es") return es_val_collector_set(inputs)
	if (locale === "fr") return fr_val_collector_set(inputs)
	if (locale === "de") return de_val_collector_set(inputs)
	if (locale === "ja") return ja_val_collector_set(inputs)
	if (locale === "zh") return zh_val_collector_set(inputs)
	if (locale === "ar") return ar_val_collector_set(inputs)
	if (locale === "id") return id_val_collector_set(inputs)
	if (locale === "it") return it_val_collector_set(inputs)
	if (locale === "ru") return ru_val_collector_set(inputs)
	if (locale === "pt") return pt_val_collector_set(inputs)
	return ko_val_collector_set(inputs)
});